import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-typing-loader',
  standalone: false,
  templateUrl: './typing-loader.component.html',
  styleUrl: './typing-loader.component.scss'
})
export class TypingLoaderComponent {
  @Input() inline = false;
}
